import { Injectable } from '@angular/core';
import { gql } from '@apollo/client';
import { Query } from 'apollo-angular';

import { DeliveryType } from '../enums/delivery-type.enum';
import { InventoryProductItem } from '../models/inventory-product-item.model';
import { InventoryStatusItem } from '../models/inventory-status-item.model';

export type B2cInventoryStatusQueryResponse<TKey extends string | number | symbol> = {
  [key in TKey]: {
    languageCode: string;
    items: InventoryStatusItem[];
  };
};

export type B2cInventoryStatusQueryVariables<TKey extends string | number | symbol> = {
  [key in TKey]: {
    deliveryType: DeliveryType;
    languageCode: string;
    requestedFromDate: string;
    requestedToDate: string;
    items: InventoryProductItem[];
  };
};

export const GetInventoryStatusQueryInputParam = 'GetInventoryStatusQueryInput';

export function getB2CInventoryStatusQuery(paramsKey: string, responseKey: string = paramsKey): string {
  return `
      ${responseKey}: inventoryStatus(inventoryStatusQuery: $${paramsKey}) {
        languageCode
        items {
          itemNumber
          sKU
          exportCatalogSKU
          inventoryStatus
          inventoryComment
        }
      }
    `;
}

@Injectable({
  providedIn: 'root',
})
export class B2CInventoryStatusQuery extends Query<
  B2cInventoryStatusQueryResponse<'inventoryStatus'>,
  B2cInventoryStatusQueryVariables<'inventory'>
> {
  override document = gql`
  query ($inventory: ${GetInventoryStatusQueryInputParam}) {
    ${getB2CInventoryStatusQuery('inventory', 'inventoryStatus')}
    }
  `;
}
